/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 13:51:08
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
  Tree,
} from 'antd'
import { DataNode } from 'antd/lib/tree'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { PayMethod } from '../../../../models/payment'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'
import { AutoExpenseModal } from '../../../user/setting/AutoExpenseModal'
import {
  getSettingDetail,
  saveSettingLabel,
  selectAutoCreateFeeVOList,
  selectSettings,
  selectTenant,
  setIsChange,
} from '../../../user/setting/settingSlice'
import styles from '../../functionSettingTabs.module.css'

export const OutpatientSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const autoCreateFeeVOList = useSelector(selectAutoCreateFeeVOList)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [autoFeeItem, setAutoFeeItem] = useState<any>()

  const [title, setTitle] = useState('create')

  const [selectIndex, setSelectIndex] = useState<any>()

  const [page, setPage] = useState({
    items: autoCreateFeeVOList?.map((v?: any, index?: any) => {
      return { ...v, indexId: index }
    }),
    total: 0,
    size: 100,
    current: 1,
  })

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  useEffect(() => {
    if (props?.selectedTab == '3') {
      if (tenant) {
        form.setFieldsValue({
          ...tenant,
          registeredFund: null,
        })
      }
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        form.setFieldsValue({
          ...settings,
        })
      }
    }
  }, [tenant, settings, props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '3') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])
  return (
    <>
      <Col className={styles.settingOutPatient}>
        <Form
          form={form}
          onFinish={(values) => {
            const pattern = /^[0-9]*$/

            const t = _.chain(values)
              .omitBy((_, k) => pattern.test(k))
              .value() as Tenant

            const f = _.chain(values)
              .pickBy((_, k) => pattern.test(k))
              .mapValues(
                (v, k) =>
                ({
                  type: k,
                  value: v?.toString(),
                } as Settinglable)
              )
              .values()
              .value()
              setButtonLoading(true)
            dispatch(
              saveSettingLabel({
                tenant: {
                  ...tenant,
                  ...t,
                },
                functionList: f,
                autoCreateFees: page.items?.map((x: any) => {
                  return {
                    materialsCatalogIds: x.materialsCatalogIds,
                    treatmentServiceIds: x.treatmentServiceIds,
                    conditionType: x.conditionType,
                    countType: x?.countType,
                    conditionMaterialsCatalogIds:
                      x.conditionMaterialsCatalogIds,
                    conditionTreatmentServiceIds:
                      x.conditionTreatmentServiceIds,
                    conditionUsemethod: x.conditionUsemethod,
                    projectCount: x.projectCount,
                  }
                }),
              })
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功,部分配置需要重新登陆后生效',
                  duration: 3,
                })
                dispatch(getSettingDetail())
              })
              .catch(() => {
                notification.error({ message: '机构设置保存失败', duration: 3 })
                dispatch(getSettingDetail())
              })
              .finally(() => {
                dispatch(setIsChange(false))
                setButtonLoading(false)
              })
          }}
          onValuesChange={(values, all) => {
            dispatch(setIsChange(true))
          }}
        >
          <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='患者复诊标记' name={Checks.HZFZBJ}>
                <Radio.Group
                  onChange={(e) => {
                    return
                  }}
                >
                  <Radio value={'1'}>默认初诊</Radio>
                  <Radio value={'2'}>
                    {hisVersion === 1
                      ? '有挂号记录的默认复诊'
                      : '老客户默认复诊'}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='皮试管理'
                name={Checks.Psgl}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，开处方时设置了皮试的药品需要先进行皮试，皮试结果登记后才能进行结算
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='诊间结算'
                name={Checks.Zjjs}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，在接诊时可以直接进行结算
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='零库存开药'
                name={Checks.Lkcky}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                  onChange={(v: any) => {
                    dispatch(
                      setSettings({
                        [Settings.Recipe.TcmIgnoreStorage]: v,
                        [Settings.Recipe.IgnoreStorage]: v,
                        [Settings.Recipe.TcmUseSpecifiedBatch]: !v,
                        [Settings.Recipe.UseSpecifiedBatch]: !v,
                      })
                    )
                  }}
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，开方搜索范围为商品目录列表，并且不需要发药
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='医生开关提醒'
                name={Checks.Gbkdysstx}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，接诊其他医生的患者时会提示非本医生的患者
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='药品搜索方式：' name={Checks.YPSSFS}>
                <Radio.Group
                  onChange={(e) => {
                    return
                  }}
                >
                  <Radio value={'1'}>药品名称或追溯码搜索</Radio>
                  <Radio value={'0'}>药品名称或条形码搜索</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Row style={{ display: 'flex' }}>
              <Col className={styles.titleLineHeight}>开方自动计算 :</Col>
              <Col className={styles.rowHeight} style={{ flex: 1 }}>
                <Form.Item name={Checks.ZDJSTS} valuePropName='checked'>
                  <Checkbox>自动计算天数(保存前)</Checkbox>
                </Form.Item>
                <Form.Item name={Checks.ZDJSTSBCH} valuePropName='checked'>
                  <Checkbox>自动计算天数(保存后)</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='开方自动生成费用'
                name={Checks.KFZDSCFY}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Button
                style={{ marginLeft: '150px' }}
                type='primary'
                onClick={() => {
                  setIsModalVisible(true)
                  setAutoFeeItem({})
                  setTitle('create')
                }}
              >
                添加
              </Button>
            </Col>
            <Col
              className={styles.rowHeight}
              span={23}
              style={{ marginLeft: '150px', width: '80%' }}
            >
              <EditableList
                page={page}
                bordered
                pagination={false}
                columns={[
                  {
                    title: '序号',
                    key: 'order',
                    align: 'center',
                    width: '2rem',
                    render: (_1, _2, index) => `${index + 1}`,
                  },
                  {
                    title: '自动生成费用',
                    dataIndex: 'projectDataName',
                    width: '4rem',
                    align: 'center',
                  },
                  {
                    title: '触发条件类型',
                    dataIndex: 'conditionType',
                    width: '4rem',
                    align: 'center',
                    render: function UserSettings(_, u: any): ReactElement {
                      return (
                        <Space>
                          {u.conditionType === 1 ? '药品/诊疗项目' : '用法'}
                        </Space>
                      )
                    },
                  },
                  {
                    title: '内容',
                    dataIndex: 'conditionDataName',
                    width: '8rem',
                    align: 'center',
                    render: function UserSettings(_, u: any): ReactElement {
                      return (
                        <Space>
                          {u.conditionType === 1
                            ? u.conditionDataName
                            : u.conditionUsemethod}
                        </Space>
                      )
                    },
                  },
                  {
                    title: '操作',
                    key: 'actions',
                    width: '4rem',
                    align: 'center',
                    render: function UserSettings(
                      _,
                      u: any,
                      index
                    ): ReactElement {
                      return (
                        <Space>
                          <a
                            onClick={() => {
                              setIsModalVisible(true)
                              setSelectIndex(u?.indexId)
                              setAutoFeeItem({
                                ...u,
                                oldConditionType: u?.conditionType,
                                oldProjectDataName: u?.projectDataName,
                                oldProjectData: u?.projectData,

                                oldConditionData:
                                  u?.conditionType == 1 ? u?.conditionData : [],
                                oldConditionDataName:
                                  u?.conditionType == 1
                                    ? u?.conditionDataName
                                    : '',

                                oldConditionUsemethod: u?.conditionUsemethod,
                              })

                              setTitle('edit')
                            }}
                          >
                            编辑
                          </a>
                          <a
                            onClick={() => {
                              const list = [...page.items]
                              list.splice(index, 1)
                              setPage({
                                ...page,
                                items: list,
                              })
                            }}
                          >
                            删除
                          </a>
                        </Space>
                      )
                    },
                  },
                ]}
              />
            </Col>
          </div>
          <Row>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  history.go(-1)
                }}
                style={{
                  float: 'right',
                  marginRight: '10px',
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{
                  float: 'left',
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
      <AutoExpenseModal
        visible={isModalVisible}
        maskClosable={false}
        onCancel={() => {
          setIsModalVisible(false)
          // dispatch(getSettingDetail())
        }}
        title={title}
        editDetailMessage={autoFeeItem}
        onSuccess={(m: any) => {
          if (title == 'create') {
            setPage({
              ...page,
              items: page?.items?.length
                ? [...page?.items, m]?.map((v: any, index: any) => {
                  return { ...v, indexId: index }
                })
                : [m]?.map((v: any, index: any) => {
                  return { ...v, indexId: index }
                }),
            })
          } else {
            const data = page?.items?.map((val: any, index?: any) => {
              return {
                ...val,
                projectCount:
                  index == selectIndex ? m?.projectCount : val?.projectCount,
                countType: index == selectIndex ? m?.countType : val?.countType,
                indexId: index,
                treatmentServiceIds:
                  index == selectIndex
                    ? m?.treatmentServiceIds
                    : val?.treatmentServiceIds,
                materialsCatalogIds:
                  index == selectIndex
                    ? m?.materialsCatalogIds
                    : val?.materialsCatalogIds,
                conditionTreatmentServiceIds:
                  index == selectIndex
                    ? m?.conditionTreatmentServiceIds
                    : val?.conditionTreatmentServiceIds,
                conditionMaterialsCatalogIds:
                  index == selectIndex
                    ? m?.conditionMaterialsCatalogIds
                    : val?.conditionMaterialsCatalogIds,
                projectDataName:
                  index == selectIndex
                    ? val?.projectDataName == m?.oldProjectDataName
                      ? m?.projectDataName
                      : val?.projectDataName
                    : val?.projectDataName,
                projectData:
                  index == selectIndex
                    ? val?.projectData?.length == m?.oldProjectData?.length
                      ? m?.projectData
                      : val?.projectData
                    : val?.projectData,
                conditionData:
                  index == selectIndex
                    ? val?.conditionData?.length == m?.oldConditionData?.length
                      ? m?.conditionData
                      : val?.conditionData
                    : val?.conditionData,
                conditionType:
                  index == selectIndex
                    ? val?.conditionType == m?.oldConditionType
                      ? m?.conditionType
                      : val?.conditionType
                    : val?.conditionType,
                conditionDataName:
                  index == selectIndex
                    ? val?.conditionDataName == m?.oldConditionDataName
                      ? m?.conditionDataName
                      : val?.conditionDataName
                    : val?.conditionDataName,
                conditionUsemethod:
                  index == selectIndex
                    ? val?.conditionUsemethod == m?.oldConditionUsemethod
                      ? m?.conditionUsemethod
                      : val?.conditionUsemethod
                    : val?.conditionUsemethod,
              }
            })
            setPage({
              ...page,
              items: data,
            })
          }

          setIsModalVisible(false)
        }}
      />
    </>
  )
}
